import { render, staticRenderFns } from "./GuideWebsitePage.vue?vue&type=template&id=7608c935&scoped=true&lang=pug&"
import script from "./GuideWebsitePage.vue?vue&type=script&lang=ts&"
export * from "./GuideWebsitePage.vue?vue&type=script&lang=ts&"
import style0 from "./GuideWebsitePage.vue?vue&type=style&index=0&id=7608c935&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7608c935",
  null
  
)

export default component.exports